// Generación local de avatares Open Peeps (DiceBear) a partir del catálogo de presets.
// 100% local (sin solicitudes externas), igual que el avatar de iniciales (avatarUtils.js).
import { createAvatar } from '@dicebear/core'
import { openPeeps } from '@dicebear/collection'
import { OPEN_PEEPS_PRESETS, getPresetById } from './avatarFacesCatalog'

// Cache module-level: como los presets son finitos (≤64), cada SVG se genera UNA vez y se
// reusa en toda la app (la grilla con cientos de filas no regenera por fila). Clave: preset id.
const _cache = new Map()

// Devuelve un SVG data-URI para el preset, o null si el id no existe (fallback a iniciales).
export function getFaceAvatar(presetId) {
  if (!presetId) return null
  if (_cache.has(presetId)) return _cache.get(presetId)
  const preset = getPresetById(presetId)
  if (!preset) return null
  const uri = createAvatar(openPeeps, { ...preset.options, size: 96 }).toDataUri()
  _cache.set(presetId, uri)
  return uri
}

export function listFacePresets() {
  return OPEN_PEEPS_PRESETS
}
